export default function ErrorPage() {
    return (
        <div>
            <h2>Unexpected Application Error!</h2>
        </div>
    );
}
